// extracted by mini-css-extract-plugin
module.exports = {"CancelButton":"CancelButton_CancelButton__oKE1H","CancelButtonPlaceholder":"CancelButton_CancelButtonPlaceholder__zFVxC"};